var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.5,28.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.5,
    y: -14.5,
    width: 29,
    height: 29,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.35;1",
    begin: "-0.3s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.5,28.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.5,
    y: -14.5,
    width: 29,
    height: 29,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.35;1",
    begin: "-0.2s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.5,71.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.5,
    y: -14.5,
    width: 29,
    height: 29,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.35;1",
    begin: "0s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.5,71.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.5,
    y: -14.5,
    width: 29,
    height: 29,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.35;1",
    begin: "-0.1s"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loader-white.28e3d9e1375b4086cf903729ce46063e.svg";
export { ForwardRef as ReactComponent };